module.exports = __webpack_public_path__ + "img/shanxifuzhuanggongchengLogo.2158f5f9.png";